// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"abfe7f57","453":"5565870f"}[chunkId] + ".chunk.js";
};